<!-- Activity Log Modal -->
<div
  class="refund-activity-modal"
  role="dialog"
  aria-labelledby="activity-title"
  aria-describedby="activity-desc"
>
  <div class="dialoghead assignAdvo_wrapper">
    <div class="activity-box">
    <h1 id="activity-title" class="mat-mdc-dialog-title log-custom-dialog-title">
      Refund Activity Log
    </h1>

      <!-- Sort button in header (icon-only) -->
      <button
        mat-icon-button
        class="sort-btn"
        (click)="toggleOrder()"
        [matTooltip]="
          'Sort: ' + (order === 'asc' ? 'Oldest → Newest' : 'Newest → Oldest')
        "
        aria-label="Toggle sort order"
      >
        <mat-icon>swap_vert</mat-icon>
      </button>
    </div>

    <!-- Corner close -->
    <button
      mat-icon-button
      mat-dialog-close
      class="close-btn-modal material-icons log-cutom-close"
      aria-label="Close"
    >
      close
    </button>
  </div>

  <mat-dialog-content class="activity-content">
    <p id="activity-desc" class="modal-subtitle">
      A chronological history of actions taken on this refund request.
    </p>

    <!-- Optional header info -->
    <div class="order-summary" *ngIf="headerInfo">
      <div class="order-id">
        <strong>Refund:</strong>
        <span>#{{ headerInfo.refundNumber || "N/A" }}</span>
      </div>
      <div class="order-meta">
        <div class="meta-item" *ngIf="headerInfo.orderNumber">
          <strong>Order :</strong>
          <span>#{{ headerInfo.orderNumber }}</span>
        </div>
        <div class="meta-item" *ngIf="headerInfo.createdOn">
          <strong>Created :</strong>
          <span>{{ headerInfo.createdOn | date : "medium" }}</span>
        </div>
        <div class="meta-item" *ngIf="headerInfo.totalAmount !== undefined">
          <strong>Total :</strong>
          <span>${{ headerInfo.totalAmount | number : "1.2-2" }}</span>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <!-- <div class="loading" *ngIf="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div> -->

    <!-- Timeline -->
    <ng-container *ngIf="groups?.length; else emptyState">
      <div class="timeline" aria-live="polite">
        <div
          class="timeline-group"
          *ngFor="let g of groups; trackBy: trackGroup"
        >
          <div class="group-date">{{ g.label }}</div>

          <div
            class="timeline-item"
            *ngFor="let item of g.items; trackBy: trackItem"
          >
            <div
              class="icon-wrap"
              [ngClass]="iconClass(item.type)"
              aria-hidden="true"
            >
              <mat-icon class="custom-mat-icon">{{ icon(item.type) }}</mat-icon>
            </div>

            <div class="item-body">
              <div class="item-head">
                <span class="when">{{
                  item.createdAt | date : "mediumTime"
                }}</span>
                <span class="dot">•</span>
                <span class="actor" *ngIf="item.actor?.name; else anon">
                  {{ item.actor?.name }}
                  <span class="role" *ngIf="item.actor?.role"
                    >({{ formatRole(item.actor?.role || "") }})</span
                  >
                </span>
                <ng-template #anon
                  ><span class="actor">System</span></ng-template
                >
              </div>

              <div class="desc">{{ item.description }}</div>

              <div class="meta" *ngIf="item.metadata">
                <details>
                  <summary>Details</summary>
                  <pre>{{ item.metadata | json }}</pre>
                </details>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Empty -->
    <ng-template #emptyState>
      <div class="empty-state">No activity yet.</div>
    </ng-template>
  </mat-dialog-content>
</div>
